import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MainContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 38px;
    margin-bottom: 12px;
    ${media.mobileDevice`     
     margin-top: 16px;
     margin-bottom: 18px;
    `}
`;

export const CartTitle = styled.div`

    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    height: 34px;
    width: ${({ width }) => (width ? width : '40px')};
    font-size: 20px;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 22px;
     width: 40%;
    `}
`;

export const CartAction = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    display:flex;
    opacity: 1;
    //  height: 34px;
    // width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    cursor: pointer;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 22px;
     width: 40%;
    `}
`;

export const EmptyCartContainer = styled.div`
    font-size: 12px;
    color: #1010eb;
    line-height: 21px;
`;

export const AddIcon = styled.div`
    // display: ${({ display }) => (display ? display : 'contents')};
    // padding: ${({ padding }) => (padding ? padding : '0px 5px 2px')};
    display: ${({ isReviewSubmitScreen, display }) =>
        isReviewSubmitScreen ? null : display ? display : 'contents'};
    padding: ${({ isReviewSubmitScreen, padding }) =>
        isReviewSubmitScreen ? null : padding ? padding : '0px 5px 2px'};
`;
export const NoProductsAddedLabel = styled.div`
    display: flex;
    color: #202124;
    opacity: 0.7;
    //font of label changed to normal
    font-family: 'AvenirNextWorld Regular';
    height: 24px;
    font-size: 14px;
    margin-top: 4px;
    ${media.mobileDevice`
        margin-top:2px;
        margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    `}
`;

export const PopupTitle = styled.div`
    color: #130e4a;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 18px;
    ${media.mobileDevice`    

    `};
`;
export const PopupContainer = styled.div`
    width: 450px;
    height: 275px;
    ${media.mobileDevice`    
     width: 334px;
    `};
`;
export const Title = styled.div``;
export const Icon = styled.div`
    border: 1px solid #ffffff;
    opacity: 1;
    background: transparent url(${({ mobilePath }) => mobilePath}) 0% 0%
        no-repeat padding-box;
    width: 22px;
    height: 23px;
    ${media.mobileDevice`
    
    `}
`;

export const ListItems = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 430px;
    height: 220px;
    ${media.mobileDevice`
    width: 310px;
    height: 220px;
    `}
`;

export const ListItem = styled.div`
    display: flex;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 4px #00000029;
    border-radius: 6px;
    opacity: 1;
    flex-direction: row;
    justify-content: space-between;
    margin: 0px 0px 7px 0px;
    color: #1010eb;
    font-family: 'AvenirNextWorld Demi';
    padding: 10px 10px 10px 20px;
    cursor: pointer;
    ${media.mobileDevice`
    
    `}
`;

export const ArrowIcon = styled.div`
    background: transparent url(${({ mobilePath }) => mobilePath}) 0% 0%
        no-repeat padding-box;
    opacity: 1;
    width: 24px;
    height: 24px;
    ${media.mobileDevice`
    
    `}
`;

export const ProductMethodsContainer = styled.div`
    display: flex;
    margin: 5px;
    padding: 10px;
    color: #1010eb;
    font-size: 14px;
    width: 60%;
`;

export const CartContainer = styled.div`
    display: grid;
    grid-template-columns: 32% 32% 32%;
    width: 100%;
    justify-content: flex-start;
    padding: 16px 0 16px 0;
    column-gap: ${({ columnGap }) => (columnGap ? columnGap : '15px')};
    row-gap: 15px;
    ${media.mediumDevice`
        grid-template-columns: 48.5% 48.5%;
    `}
    ${media.smalDevice`
        grid-template-columns: 48.5% 48.5%;
    `}
    ${media.mobileDevice`
        grid-template-columns: 100%;
    `}
`;

export const NoteSummaryContainer = styled.div`
    display: flex;
    flex-direction: ${({flexDirection}) => flexDirection ? flexDirection : 'row' };
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '20px'};
    width: 100%;
    ${media.mobileDevice`
    width: 100%;
    justify-content: space-between;
    flex-direction:column-reverse;         
        /* margin-top: 16px; */
    `}
`;
export const CartHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: 1120px;
    // height: 36px;
    margin-top: 20px;
    // margin-bottom: 12px;
    ${media.mobileDevice`     
     margin-top: 16px;
     margin-bottom: 18px;
    `}
`;
export const CartActionItemsContainer = styled.div`
    display: flex;
    width: ${({ width }) => (width ? width : '244px')};
    height: 20px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '-10px')};
    // cursor: pointer;
    ${media.mobileDevice`
    //  display: none;
     margin-right:-30px;
     `}
`;

export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : null)};
     
    
        
        
    `}
`;
export const Text = styled.div`
    width: ${({ width }) => (width ? width : '83px')};
    height: ${({ height }) => (height ? height : '20px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    font-weight: 600;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '')};
`;
export const CartActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    // width: 100%;
    height: 32px;
    gap: ${({ gap }) => (gap ? gap : '32px')};

    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
`;
export const AddProductsMobileMenuCard = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
`;
export const AddProductsMenuCard = styled.div`
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '')};
    margin-bottom: 10px;
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    height: ${(props) => {
        props.height ? props.height : '190px';
    }};
    width: 100%; //originally 66%
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;

    ${media.smalDevice`
        width:${(props) =>
            props.widthOnSmallDevice ? props.widthOnSmallDevice : '100%'}
    `}
    @media only screen and (min-device-width: 1024px) and
        (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        width: ${(props) => (props.mediumWidth ? props.mediumWidth : '60%')};
    }

    @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: landscape) {
        /* For landscape layouts only */
        width: ${(props) =>
            props.landScapeWidth ? props.landScapeWidth : '60%'};
    }
    ${media.mobileDevice`     
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '10px 0')};
        padding: 0 0 10px 0;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
    `}
`;
export const CartHeaderTitle = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: ${({ color }) => (color ? color : '#030330')};
    height: 36px;
    //width: ${({ width }) => (width ? width : '82px')};
    width: ${({ width }) => (width ? width : 'auto')};
    font-size: 20px;
    font-weight: 600;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
     width: 100%;
             margin-top: -30px;
        padding: 15px;
    `}
`;
export const AddProductsMethodCardItems = styled.div`
   display: flex;
    margin: ${({ setMargin }) => (setMargin ? setMargin : '5px')};
    padding: ${({ setPadding }) => (setPadding ? setPadding : '10px')};
    color: #1010eb;
    font-size: 14px;
    cursor: pointer;
    // width: ${({ setWidth }) => (setWidth ? setWidth : '45%')};
      margin-left:${({ marginLeft }) => (marginLeft ? marginLeft : '15px')};
`;
export const AddProductsMenuCardItems = styled.div`
    display: flex;
    margin: ${({ setMargin }) => (setMargin ? setMargin : '5px')};
    padding: ${({ setPadding }) =>
        setPadding ? setPadding : '10px 10px 0px 10px'};
    color: ${({ color }) => (color ? color : '#1010eb')};
    font-size: ${({ fonstSize }) => (fonstSize ? fonstSize : '14px')};
    cursor: pointer;
    width: ${({ setWidth }) => (setWidth ? setWidth : '45%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};

    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0')};
`;